import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "react-dropdown-tree-select/dist/styles.css";
import { FaInfoCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import {
  loadRecentStockPrice,
  loadStockPriceNearDate
} from "../libs/stockPricesLib";
import { formatCurrency } from "../libs/utils";

export default function StockPriceDisplay(props) {
  const [recentStockPrice, setRecentStockPrice] = useState({});

  useEffect(() => {
    async function fetchStockPrice() {
      if (!props.stockSymbol) {
        return;
      }

      try {
        let data;
        if (!props.targetDate) {
          data = await loadRecentStockPrice(props.stockSymbol);
        } else {
          data = await loadStockPriceNearDate(
            props.activeCompany,
            props.targetDate
          );
        }
        setRecentStockPrice(data);
      } catch (e) {
        toast.error(e);
      }
    }
    fetchStockPrice();
  }, [props.stockSymbol, props.activeCompany, props.targetDate]);

  return (
    <span className="d-flex align-items-center">
      {recentStockPrice.date ? (
        <>
          <OverlayTrigger
            placement="right"
            delay={{ show: 150, hide: 250 }}
            overlay={
              <Tooltip style={{ zIndex: 9999999999 }}>
                {recentStockPrice.priceDesc} price on <br />{" "}
                {recentStockPrice.date}
              </Tooltip>
            }
          >
            <div className="d-flex align-items-center">
              <div>
                {props.label ? props.label + " " : null}
                {formatCurrency(recentStockPrice.displayPrice || 0)}{" "}
              </div>
              <FaInfoCircle
                className="pull-right"
                style={{
                  marginLeft: "5px",
                }}
              />
            </div>

          </OverlayTrigger>
        </>
      ) : (
          props.initialDisplayPrice
        )}
    </span>
  );
}
